import {
  getDashboardUserProfile,
  isDashboardActivationKeyActive,
  type DashboardUserProfile,
} from '@services/firebase'

function wait(milliseconds: number) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, milliseconds)
  })
}

export async function waitForActivatedDashboardProfile({
  activationCode,
  delayMs = 1500,
  maxAttempts = 6,
}: {
  readonly activationCode: string
  readonly delayMs?: number
  readonly maxAttempts?: number
}): Promise<DashboardUserProfile> {
  let latestProfile = await getDashboardUserProfile()

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (
      latestProfile.activationCode === activationCode &&
      isDashboardActivationKeyActive(latestProfile.activation_key)
    ) {
      return latestProfile
    }

    await wait(delayMs)
    latestProfile = await getDashboardUserProfile()
  }

  return latestProfile
}
